import React from 'react';
import Card from '@material-ui/core/Card';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import {style_bleu} from '../references.js'

class Segment extends React.Component {
	constructor(props) {
		super(props);
		this.props = props;
		this.state = {datas: []}
	}

	setRecap(value) {
		this.setState({
			datas: value
		});
	}

	render() {
	  const { datas,hide,code} = this.props;
        if (!datas) {
            return null;
        }
	    return (
		    <Card style={hide ? {display:'none'} :{marginLeft: this.props.marginLeft}}>
		        <Table>
		        {
		            <TableHead>
		                <TableRow>
		                    <TableCell>
							{this.props.title ? this.props.title : 'Récapitulatif'}
		                    </TableCell>
		                  	<TableCell/>
		                </TableRow>
						<TableRow >
		                    <TableCell style={this.props.tiket ? {fontWeight:'bold',fontSize:14} : { color: 'purple'  }}>
		                        Code
		                    </TableCell>
		                  	<TableCell style={this.props.tiket ? {fontWeight:'bold',fontSize:14} : { color: 'purple'  }}>
		                  		{code}
		                  	</TableCell>
		                </TableRow>
		            </TableHead>
		        }
		            <TableBody>
		               {datas.map(segment => (
		                    <TableRow key={segment.id} style={ {height:42}}>
		                        <TableCell style={ segment.id==='montant' ?  style_bleu:null}>{segment.label}</TableCell>
								<TableCell style={ segment.id==='montant' ? style_bleu: null	}>
		                            {segment.name}
		                        </TableCell>
		                    </TableRow>
		                ))

		            } 
		            </TableBody>
		        </Table>
		    </Card>
	    )
	}
}

export default Segment;